module.exports = __webpack_public_path__ + "static/media/team-dachlissen.e0274442.jpg";